import ProductFactory from '../../product-factory';
import BoardCreationParameters from './board-creation-parameters';
import Board, { MaterialChoices } from '../../../../model/product/board/board';
import BoardPlacement from '../../../../model/product/board/board-placement';
import Product from '../../../../model/product/product';
import ProductPlacement from '../../../../model/product/product-placement';
import BoardPart, {
  DEFAULT_DISTANCE_TO_BOTTOM,
} from 'src/app/model/product/board/board-part';

export default class BoardFactory extends ProductFactory<BoardCreationParameters> {
  protected createProductTemplate(
    parameters: BoardCreationParameters
  ): Product {
    return new Board();
  }

  protected createProductPlacement(): ProductPlacement {
    const toReturn = new BoardPlacement();
    toReturn.productPlacementType = 'BoardPlacement';
    return toReturn;
  }

  getProductCreationParameters(parameters: any): BoardCreationParameters {
    return null;
  }

  createBoardPart(): BoardPart {
    const toReturn = new BoardPart();
    toReturn.paintedPosts = false;
    toReturn.material = MaterialChoices.ALUCOBOND;
    toReturn.distanceToBottom = DEFAULT_DISTANCE_TO_BOTTOM;
    return toReturn;
  }
}
